module.exports = __webpack_public_path__ + "src/components/Cut4/images/bg@0.5x.webp";